import PropTypes from 'prop-types'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'
import AlertComponent from '../../../components/stories/molecules/alerts'
import { buttonVariantOptions } from '../../../components/stories/atoms/button/constants'
import { alertVariantComponentOptions } from '../../../components/stories/molecules/alerts/constants'

// The alert already renders its description inside a <p>, so the second
// paragraph the copy carries as a `<p>` tag has to be a block-level span —
// a nested paragraph would be invalid markup.
const DescriptionParagraph = styled.span`
  display: block;
  margin-top: 8px;
`

const DeactivatePlanAlert = ({ onClose, onConfirm, isLoading, count = 1 }) => {
  const { formatMessage } = useIntl()

  const handleLeaveProject = (e) => {
    onConfirm(e)
    onClose(e)
  }

  return (
    <AlertComponent
      activeOverlay={true}
      variant={alertVariantComponentOptions.DANGER}
      // Both plural branches of the copy carry their own question mark.
      title={formatMessage({ id: 'plans_dialog_deactivate_title' }, { count })}
      description={
        <FormattedMessage
          id="plans_dialog_deactivate_description"
          values={{
            count,
            p: (chunks) => <DescriptionParagraph>{chunks}</DescriptionParagraph>
          }}
        />
      }
      onClickOutside={onClose}
      actionButtons={[
        {
          variant: buttonVariantOptions['TERTIARY-HOLLOW'],
          onClick: onClose,
          children: formatMessage({ id: 'cancel' }),
          fullWidth: true
        },
        {
          variant: buttonVariantOptions['PRIMARY-DESTRUCTIVE'],
          onClick: handleLeaveProject,
          children: formatMessage({ id: 'deactivate' }),
          isLoading,
          disabled: isLoading,
          fullWidth: true
        }
      ]}
    />
  )
}

DeactivatePlanAlert.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  count: PropTypes.number
}

export default DeactivatePlanAlert
